/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import { PATHS } from './navigation/routes';
import { TransactionComplete } from './pages/TransactionComplete/TransactionComplete';
import { LandingPage } from './pages/LandingPage/LandingPage';
import { Dashboard } from './pages/Dashboard/Dashboard';

export const App: React.FC = () => {
    return (
        <Router>
            <Switch>
                <Route exact path={PATHS.home}>
                    <LandingPage />
                </Route>
                <Route exact path={PATHS.dashboard}>
                    <Dashboard />
                </Route>
                <Route exact path={PATHS.transactionComplete}>
                    <TransactionComplete />
                </Route>
            </Switch>
        </Router>
    );
};
